import loadable from '@loadable/component';
import { Loader } from '@/components';

const AsyncLoanExamples = loadable(() => import('./LoanExamples'), {
  fallback: <Loader />,
});

export default AsyncLoanExamples;
